import React from "react";
import styles from "./style.module.scss";

const LoadingTBody = (props) => {
  const { aheadLoading = false, extraColumns = true, isLoading, loadingRows = 5 } = props;

  const renderLoadingRows = () => {
    return isLoading && [...Array(loadingRows)].map((i, index) => loadingRow(index));
  }

  const loadingRow = (index) => {
    return (<tr key={index} className={styles.row}>
      {extraColumns && (<td></td>)}
      <td colSpan="20" className={styles.animatedColumn}><span></span></td>
    </tr>);
  }

  return (
    <tbody>
      {(!isLoading || aheadLoading) && props.children}
      {renderLoadingRows()}
    </tbody>
  );
}

export default LoadingTBody;